import moment from "moment";

export const DATE_GRANULARITY_VALUE = 'day';
export const WEEK_GRANULARITY_VALUE = 'week';
export const MONTH_GRANULARITY_VALUE = 'month';

export class BaseDate {
  static values = ['date', 'datetime'];

  getDefaultValue() {};

  static getDate(type: string, granularity: string): BaseDate|undefined {
    if (!BaseDate.values.includes(type)) {
      return undefined
    }
    if (granularity === WEEK_GRANULARITY_VALUE) {
      return new WeekDate();
    } else if (granularity === MONTH_GRANULARITY_VALUE) {
      return new MonthDate();
    } else {
      return new DayDate();
    }
  }
}

class DayDate extends BaseDate {

  getDefaultValue(): string[] {
    return [date2string(moment().subtract(7,"days")), date2string(moment())];
  }
}

class WeekDate extends BaseDate {
  getDefaultValue(): string[] {
    return [date2string(moment().subtract(4,"weeks")), date2string(moment())];
  }
}

class MonthDate extends BaseDate {
  getDefaultValue(): string[] {
    return [date2string(moment().subtract(1,"months")), date2string(moment())];
  }
}

function date2string(moment: moment.Moment): string  {
  return moment.format("YYYY-MM-DD");
}
